module.exports = __webpack_public_path__ + "img/bee-img-auth-sideimg2.b1725e63.png";